export const normalizeCheckpointId = (value: unknown) =>
  (value ?? '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/_/g, '-')
    .replace(/[^a-z0-9-]/g, '');

export const normalizeCheckpointVersion = (value: unknown) =>
  (value ?? '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '');

export const makeCheckpointKey = (id: unknown, version: unknown) => {
  const idKey = normalizeCheckpointId(id);
  const verKey = normalizeCheckpointVersion(version);
  return `${idKey}::${verKey}`;
};

export type CheckpointVersion = string | number;

export interface CheckpointVersionSource {
  checkpointVersion?: CheckpointVersion | null;
  version?: CheckpointVersion | null;
}

export const hasCheckpointVersionValue = (
  value: unknown,
): value is CheckpointVersion => {
  if (value === null || value === undefined) return false;
  if (typeof value !== 'string' && typeof value !== 'number') return false;
  return `${value}`.trim() !== '';
};

export const getCheckpointVersion = (
  source?: CheckpointVersionSource | null,
): CheckpointVersion | null => {
  const raw = source?.checkpointVersion ?? source?.version;
  return hasCheckpointVersionValue(raw) ? raw : null;
};

export const getCheckpointVersionString = (
  source?: CheckpointVersionSource | null,
): string | null => {
  const version = getCheckpointVersion(source);
  return version === null ? null : `${version}`;
};
